<div class="container p-0">
  <mat-dialog-content class="thera-mat-modal">
    <button
      mat-icon-button
      class="close-button mat-modal-close-btn"
      [mat-dialog-close]="null"
    >
      <mat-icon class="close-icon text-dark_gray">close</mat-icon>
    </button>
    <div class="modal-dialog my-0">
      <div class="modal-content ml-5 mr-5 mt-2">
        <div class="text-center mb-12">
          <h4 class="font-semibold text-2xl" 
          ngClass="{{ leftAlign ? 'text-left' : 'text-center' }}" 
          [innerHtml]="title"></h4>
        </div>
        <div class="modal-body">
          <ng-container *ngIf="loaded || !data.promise">
            <h6
              class="mt-5 mb-10"
              ngClass="{{ leftAlign ? 'text-left' : 'text-center' }}"
              [innerHtml]="message"
            ></h6>
            
            <h6 *ngIf="note" class="mb-10">NOTE: {{ note }}</h6>
          </ng-container>

          <ng-container 
            *ngTemplateOutlet="contentTemplate; context: templateContext">
          </ng-container>
          
          <div class="mb-5" *ngIf="isAddPractitioner && dropdownOptions.length">
            <label>Practitioner</label>
            <thera-dropdown 
              class="question-feild-dropdown"
              [options]="dropdownOptions || []" 
              [defaultSelection]="defaultDropdownSelection"
              [showRequired]="false"
              (optionSelected)="dropDownValueChange($event)"> 
            </thera-dropdown>
          </div>

        </div>

        <div class="block text-center mb-8">
          <div class="mb-5">
            <button
              mat-button
              tabindex="-1"
              [ngClass]="{ 'is-error': isError }"
              (click)="action()"
              *ngIf="!hideMainButton"
            >
              {{ buttonText }}
            </button>
          </div>
          <div>
            <a
              cdkFocusInitial
              *ngIf="!hideCancelButton"
              (click)="dialog.close(false)"
            >
              {{cancelText}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
